__turbopack_context__.v({
  "actions": "TasksCompleteProfileDialog-module-scss-module__7TYAeq__actions",
  "cornerClose": "TasksCompleteProfileDialog-module-scss-module__7TYAeq__cornerClose",
  "cornerIcon": "TasksCompleteProfileDialog-module-scss-module__7TYAeq__cornerIcon",
  "description": "TasksCompleteProfileDialog-module-scss-module__7TYAeq__description",
  "dialog": "TasksCompleteProfileDialog-module-scss-module__7TYAeq__dialog",
  "fieldIconSvg": "TasksCompleteProfileDialog-module-scss-module__7TYAeq__fieldIconSvg",
  "fieldIconWrap": "TasksCompleteProfileDialog-module-scss-module__7TYAeq__fieldIconWrap",
  "fieldItem": "TasksCompleteProfileDialog-module-scss-module__7TYAeq__fieldItem",
  "fieldItems": "TasksCompleteProfileDialog-module-scss-module__7TYAeq__fieldItems",
  "fieldLabel": "TasksCompleteProfileDialog-module-scss-module__7TYAeq__fieldLabel",
  "fieldList": "TasksCompleteProfileDialog-module-scss-module__7TYAeq__fieldList",
  "fieldListLabel": "TasksCompleteProfileDialog-module-scss-module__7TYAeq__fieldListLabel",
  "glyph": "TasksCompleteProfileDialog-module-scss-module__7TYAeq__glyph",
  "inner": "TasksCompleteProfileDialog-module-scss-module__7TYAeq__inner",
  "primaryBtn": "TasksCompleteProfileDialog-module-scss-module__7TYAeq__primaryBtn",
  "secondaryBtn": "TasksCompleteProfileDialog-module-scss-module__7TYAeq__secondaryBtn",
  "title": "TasksCompleteProfileDialog-module-scss-module__7TYAeq__title",
  "warningTriangle": "TasksCompleteProfileDialog-module-scss-module__7TYAeq__warningTriangle",
});
